<template>
  <div>
    <h1>Wat mensen zeggen</h1>
    <p>Is mooi</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
